"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[60484],{

/***/ 21548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16165);
/* harmony import */ var features_day_trade_components_Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40892);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91037);
/* harmony import */ var _component_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54740);






function DayTradeBadgeBox(param) {
    var label = param.label, _isDayTrade = param.isDayTrade, isDayTrade = _isDayTrade === void 0 ? false : _isDayTrade;
    var isForcedSell = !!global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_3__/* .ForcedSellMapper */ .l5[label] || isDayTrade;
    var getBadgeLabel = function() {
        if (isForcedSell && isDayTrade) return label;
        if (isForcedSell) return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_3__/* .ForcedSellMapper */ .l5[label];
        return "DT";
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_component_styled__WEBPACK_IMPORTED_MODULE_4__/* .BadgeWrapper */ .MF, {
        isForcedSell: isForcedSell,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                component: features_day_trade_components_Icons__WEBPACK_IMPORTED_MODULE_2__/* .LightningFilledSvg */ .SY
            }),
            getBadgeLabel()
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(DayTradeBadgeBox));


/***/ }),

/***/ 76431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42298);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91037);
/* harmony import */ var _component_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54740);






var formatTime = function(time) {
    var jsDate = new Date(time);
    var formattedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(jsDate, "dd MMM yyyy");
    var formattedHour = (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(jsDate, "HH:mm:ss");
    return "".concat(formattedDate, " pukul ").concat(formattedHour, ".");
};
function DayTradeBanner(param) {
    var label = param.label, _title = param.title, title = _title === void 0 ? "Day Trade Forced Sell" : _title, timeOpen = param.timeOpen, _forcedSell = param.forcedSell, forcedSell = _forcedSell === void 0 ? false : _forcedSell;
    var isForcedSell = !!global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_3__/* .ForcedSellMapper */ .l5[label] || forcedSell;
    if (!isForcedSell) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_component_styled__WEBPACK_IMPORTED_MODULE_4__/* .BannerWrapper */ .Sh, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_component_styled__WEBPACK_IMPORTED_MODULE_4__/* .BannerTitleWrapper */ .eD, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        src: "/images/day-trade/info-danger.svg",
                        alt: "Info",
                        height: "18",
                        width: "18"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_component_styled__WEBPACK_IMPORTED_MODULE_4__/* .BannerTitle */ .TR, {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_component_styled__WEBPACK_IMPORTED_MODULE_4__/* .BannerDescription */ .gS, {
                children: [
                    "Saham ini terkena Forced Sell sesuai ketentuan Day Trade pada",
                    " ",
                    formatTime(timeOpen)
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(DayTradeBanner));


/***/ }),

/***/ 54740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MF": function() { return /* binding */ BadgeWrapper; },
/* harmony export */   "Q1": function() { return /* binding */ TableHeaderWrapper; },
/* harmony export */   "Rz": function() { return /* binding */ DebtRatioChip; },
/* harmony export */   "Sh": function() { return /* binding */ BannerWrapper; },
/* harmony export */   "TC": function() { return /* binding */ DebtRatioInfoChip; },
/* harmony export */   "TR": function() { return /* binding */ BannerTitle; },
/* harmony export */   "Zz": function() { return /* binding */ DebtRatioCountDown; },
/* harmony export */   "eD": function() { return /* binding */ BannerTitleWrapper; },
/* harmony export */   "gS": function() { return /* binding */ BannerDescription; },
/* harmony export */   "mV": function() { return /* binding */ DebtRatioOverlayProgress; },
/* harmony export */   "yP": function() { return /* binding */ DebtRatioWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 80px;\n  height: 26px;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  left: 80px;\n  top: 0;\n  height: 100%;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 16px;\n  color: #858585;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 16px;\n  color: #858585;\n\n  ",
        "\n\n  p {\n    text-wrap: nowrap;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background-color: #ffffff;\n  flex-wrap: nowrap;\n  gap: 10px;\n  cursor: pointer;\n\n  > * {\n    z-index: 2;\n  }\n\n  p {\n    text-wrap: nowrap;\n    margin: 0;\n  }\n\n  p.chip-label {\n    color: #858585;\n  }\n\n  p.chip-percentage {\n    color: #000000;\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #f2f1fe;\n  cursor: default;\n\n  p {\n    color: #8277f8;\n  }\n\n  svg {\n    width: 14px;\n    height: 14px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-radius: 4px;\n  z-index: 1;\n\n  width: ",
        ";\n  max-width: 100%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #8277f8;\n  color: #8277f8;\n  display: flex;\n  font-size: 10px;\n  font-weight: 700;\n  gap: 2px;\n  justify-content: center;\n  line-height: 14px;\n  margin-left: 7px;\n  padding: 2px 4px;\n  text-align: center;\n\n  svg {\n    width: 12px;\n    height: 12px;\n    color: #8277f8;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  background: #fdeded;\n  gap: 8px;\n  border-radius: 3px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  gap: 4px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 18px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var TableHeaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-297577d8-0"
})(_templateObject());
var DebtRatioWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-297577d8-1"
})(_templateObject1());
var DebtRatioInfoChip = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-297577d8-2"
})(_templateObject2(), function(param) {
    var color = param.color;
    return color && "\n    background-color: ".concat(color, ";\n  ");
});
var DebtRatioChip = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(DebtRatioInfoChip).withConfig({
    componentId: "sc-297577d8-3"
})(_templateObject3());
var DebtRatioCountDown = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(DebtRatioChip).withConfig({
    componentId: "sc-297577d8-4"
})(_templateObject4());
var DebtRatioOverlayProgress = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-297577d8-5"
})(_templateObject5(), function(param) {
    var _width = param.width, width = _width === void 0 ? 0 : _width;
    return "".concat(width, "%");
}, function(param) {
    var color = param.color;
    return color;
});
// BADGE
var BadgeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-297577d8-6"
})(_templateObject6(), function(param) {
    var isForcedSell = param.isForcedSell;
    return isForcedSell && "\n    background: #FDEDED;\n    color: #EE4A49;\n    border: none;\n  ";
});
// BANNER
var BannerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-297577d8-7"
})(_templateObject7());
var BannerTitleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-297577d8-8"
})(_templateObject8());
var BannerTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    family: "bold",
    size: "14px",
    color: "#333333"
}).withConfig({
    componentId: "sc-297577d8-9"
})(_templateObject9());
var BannerDescription = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    size: "13px",
    color: "#333333"
}).withConfig({
    componentId: "sc-297577d8-10"
})(_templateObject10());


/***/ }),

/***/ 74551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pz": function() { return /* binding */ EmptyStateInModal; }
/* harmony export */ });
/* unused harmony export EmptyState */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29658);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94514);








var EmptyState = function(param) {
    var _isRealized = param.isRealized, isRealized = _isRealized === void 0 ? false : _isRealized, _isRealizedFilterActive = param.isRealizedFilterActive, isRealizedFilterActive = _isRealizedFilterActive === void 0 ? false : _isRealizedFilterActive;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        align: "center",
        justify: "center",
        direction: "column",
        m: "40px",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        condition: !isRealizedFilterActive,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            src: isRealized ? "/icon/empty-state-realized.svg" : "/icon/empty-state-history.svg"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        condition: isRealized && isRealizedFilterActive,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            src: "/icon/empty-state-outline.svg"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                family: "bold",
                mt: "16px",
                mb: "6px",
                as: "h3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        condition: isRealized && !isRealizedFilterActive,
                        children: "No Realized Gain Yet"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        condition: !isRealized,
                        children: "Your History Order is Empty"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                size: "13px",
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray,
                mb: "10px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        condition: isRealized && !isRealizedFilterActive,
                        children: "You haven’t made any sell transactions yet."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        condition: isRealized && isRealizedFilterActive,
                        children: "No results found"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        condition: !isRealized,
                        children: "No stocks in your history order. Browse stocks and start investing."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                condition: !isRealized,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                    href: "/watchlist",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .DiscoverButton */ .NF, {
                        as: "a",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary,
                            family: "bold",
                            size: "12px",
                            children: "Discover Now"
                        })
                    })
                })
            })
        ]
    }));
};
var EmptyStateInModal = function() {
    return(// @ts-expect-error
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        align: "center",
        justify: "center",
        direction: "column",
        m: "40px",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                src: "/icon/empty-state-illustration.svg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                size: "13px",
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray,
                mb: "10px",
                children: "Tidak ada riwayat transaksi"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (EmptyState);


/***/ }),

/***/ 47439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ HistoryModal; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/features/day-trade/components/Banner.tsx
var Banner = __webpack_require__(76431);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/global/Collapsible/index.tsx + 1 modules
var Collapsible = __webpack_require__(80557);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/InfoSvg.tsx
var InfoSvg = __webpack_require__(42958);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/styled.ts
var styled = __webpack_require__(70098);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/constants.ts
var constants = __webpack_require__(38875);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondInfoModal.ts
var useBondInfoModal = __webpack_require__(32471);
// EXTERNAL MODULE: ./src/features/trade/components/DetailModal/index.tsx + 3 modules
var components_DetailModal = __webpack_require__(4303);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var _style_color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/features/securities/withdrawal/utils.ts
var withdrawal_utils = __webpack_require__(17921);
// EXTERNAL MODULE: ./src/features/securities/styled.ts
var securities_styled = __webpack_require__(38639);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/features/trade/components/History/utils.js
var History_utils = __webpack_require__(36675);
// EXTERNAL MODULE: ./src/features/trade/components/History/types.ts
var types = __webpack_require__(74380);
;// CONCATENATED MODULE: ./src/features/trade/components/History/DetailTableData.tsx















var getDetailTableData = function(dataTable) {
    var onClickFee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {}, openInfoModal = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(info) {};
    var dataSource = [];
    var configStatusDepositWithdrawal = [
        {
            key: "1",
            color: _style_color/* default.highgray */.Z.highgray,
            status: "PENDING"
        },
        {
            key: "2",
            color: _style_color/* default.primary */.Z.primary,
            status: "SUCCESS"
        },
        {
            key: "6",
            color: _style_color/* default.sunsetOrange */.Z.sunsetOrange,
            status: "FAILED"
        }, 
    ];
    var config = {
        gain: {
            title: "Realized Gain",
            color: _style_color/* default.primary */.Z.primary
        },
        loss: {
            title: "Realized Loss",
            color: _style_color/* default.sunsetOrange */.Z.sunsetOrange
        }
    };
    var generateRealizedValueConfig = function(value) {
        if (value === 0) {
            return {
                title: "Realized Gain",
                color: "#333333"
            };
        }
        return value < 0 ? config.loss : config.gain;
    };
    var generateItem = function(label, value) {
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "span",
                children: label
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "div",
                align: "right",
                children: value
            })
        };
    };
    var generateDateItem = function() {
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "span",
                children: "Date"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "div",
                align: "right",
                children: (0,History_utils/* formatDate */.p6)(dataTable.date)
            })
        };
    };
    var generatePriceItem = function(title) {
        var roundDown = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var price = roundDown ? (0,History_utils/* formatPriceRoundDown */.Dq)(dataTable.price) : (0,History_utils/* formatPrice */.T4)(dataTable.price);
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "span",
                children: title || "Price"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "div",
                align: "right",
                children: price
            })
        };
    };
    var generateLotItem = function(title) {
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "span",
                children: title || "Lot"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "div",
                align: "right",
                children: (0,History_utils/* formatPrice */.T4)(dataTable.lot)
            })
        };
    };
    var generateAmountItem = function(label) {
        var netAmount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var amount = netAmount ? dataTable.netamount : dataTable.amount;
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "span",
                family: "bold",
                children: label
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "div",
                align: "right",
                family: "bold",
                children: (0,History_utils/* formatPrice */.T4)(amount)
            })
        };
    };
    var generateBuySellSource = function() {
        return [
            generateDateItem(),
            generatePriceItem("Price"),
            generateLotItem("Lot Done"),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Amount"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: (0,History_utils/* formatPrice */.T4)(dataTable.amount)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Total Fee"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: (0,History_utils/* formatPrice */.T4)(dataTable.fee)
                })
            },
            generateAmountItem("Net Amount"), 
        ];
    };
    var generateStatus = function(statusText) {
        var configStatusActive = configStatusDepositWithdrawal.find(function(e) {
            return e.status === dataTable.status.toUpperCase();
        });
        return {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "span",
                children: "Status"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "div",
                align: "right",
                family: "bold",
                color: configStatusActive.color,
                children: statusText
            })
        };
    };
    var generateWithdrawMutualFund = function() {
        var configStatusActive = configStatusDepositWithdrawal.find(function(e) {
            return e.status === dataTable.status.toUpperCase();
        });
        return [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Status"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    color: configStatusActive.color,
                    children: dataTable.status
                })
            },
            generateDateItem(),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Destination"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: "Bibit"
                })
            }, 
        ];
    };
    if (dataTable.command === types/* HistoryType.BUY */.Z3.BUY) {
        dataSource = generateBuySellSource();
    }
    if ([
        types/* HistoryType.SELL */.Z3.SELL,
        types/* HistoryType.FORCED_SELL_DAY_TRADE */.Z3.FORCED_SELL_DAY_TRADE
    ].includes(dataTable.command)) {
        var ref = generateRealizedValueConfig(dataTable.realized_amount), color = ref.color, title = ref.title;
        dataSource = generateBuySellSource();
        if (!dataTable.is_realized_gain_hidden) {
            dataSource.push({
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    family: "bold",
                    children: title
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    color: color,
                    children: (0,History_utils/* getRealizedPnLText */.nE)(dataTable, 2)
                })
            });
        }
    }
    if ([
        types/* HistoryType.DEPOSIT */.Z3.DEPOSIT,
        types/* HistoryType.CASHBACK_STOCKBIT */.Z3.CASHBACK_STOCKBIT,
        types/* HistoryType.CASHBACK_BROKER_FEE */.Z3.CASHBACK_BROKER_FEE, 
    ].includes(dataTable.command)) {
        var configStatusActive = configStatusDepositWithdrawal.find(function(e) {
            return e.status === dataTable.status.toUpperCase();
        });
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Status"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    color: configStatusActive.color,
                    children: dataTable.status
                })
            },
            generateDateItem(),
            generateAmountItem("Deposit Amount"), 
        ];
        // Need to hide empty account number due to manual deposit
        // and if account number is 0000000000 to handle deposit to RDN BCA
        // with other banks
        if (dataTable.bank_account_number !== "" && dataTable.bank_account_number !== "0000000000") {
            dataSource.splice(2, 0, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Account Number"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.bank_account_number
                })
            });
        }
    }
    var isMutualFund = !!(dataTable === null || dataTable === void 0 ? void 0 : dataTable.partner_reference);
    var isBasketBuyMutualFund = isMutualFund && (dataTable === null || dataTable === void 0 ? void 0 : dataTable.mutual_fund) === "";
    if (dataTable.command === types/* HistoryType.WITHDRAW */.Z3.WITHDRAW) {
        var configStatusActive1 = configStatusDepositWithdrawal.find(function(e) {
            return e.status === dataTable.status.toUpperCase();
        });
        var transferFee = (dataTable === null || dataTable === void 0 ? void 0 : dataTable.fee) && !(dataTable === null || dataTable === void 0 ? void 0 : dataTable.is_hide_transfer_fee) ? "-".concat((0,History_utils/* formatPrice */.T4)(dataTable === null || dataTable === void 0 ? void 0 : dataTable.fee)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "free-transfer",
            children: "Gratis"
        });
        var fontFamily = !(0,utils/* isRedirectToNewCore */.JI)() || (dataTable === null || dataTable === void 0 ? void 0 : dataTable.is_hide_transfer_fee) ? "bold" : null;
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Status"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    color: configStatusActive1.color,
                    children: dataTable.status
                })
            },
            generateDateItem(),
            (0,_object_spread/* default */.Z)({}, (dataTable === null || dataTable === void 0 ? void 0 : dataTable.symbol) ? {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Transfer Method"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable === null || dataTable === void 0 ? void 0 : dataTable.symbol
                })
            } : {}),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Destination Bank"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.bank_name
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Account Number"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.bank_account_number
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    family: fontFamily,
                    children: "Withdrawal Amount"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: fontFamily,
                    children: (0,History_utils/* formatPrice */.T4)(dataTable.netamount)
                })
            },
            (0,_object_spread/* default */.Z)({}, (0,utils/* isRedirectToNewCore */.JI)() && !(dataTable === null || dataTable === void 0 ? void 0 : dataTable.is_hide_transfer_fee) ? {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Transfer Fee"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: transferFee
                })
            } : {}),
            (0,_object_spread/* default */.Z)({}, (0,utils/* isRedirectToNewCore */.JI)() ? !(dataTable === null || dataTable === void 0 ? void 0 : dataTable.is_hide_transfer_fee) && {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    family: "bold",
                    children: "Received Amount"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    children: (0,History_utils/* formatPrice */.T4)(dataTable === null || dataTable === void 0 ? void 0 : dataTable.amount)
                })
            } : {}), 
        ];
    }
    if (dataTable.command === types/* HistoryType.WITHDRAW */.Z3.WITHDRAW && isMutualFund) {
        dataSource = [
            generateWithdrawMutualFund(),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Mutual Fund"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.mutual_fund
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Transaction ID"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.partner_reference
                })
            },
            generateAmountItem("Withdrawal Amount"), 
        ];
    }
    if (dataTable.command === types/* HistoryType.WITHDRAW */.Z3.WITHDRAW && isBasketBuyMutualFund) {
        dataSource = [
            generateWithdrawMutualFund(),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Transaction ID"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.partner_reference
                })
            },
            generateAmountItem("Withdrawal Amount"), 
        ];
    }
    if (dataTable.command === types/* HistoryType.EXERCISE */.Z3.EXERCISE) {
        dataSource = [
            generateDateItem(),
            generatePriceItem("Exercise Price"),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Shares"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: (0,History_utils/* formatPrice */.T4)(dataTable.lot * constant/* lotSize */.CQ)
                })
            },
            generateAmountItem("Exercise Amount"), 
        ];
    }
    if (dataTable.command === types/* HistoryType.DIVIDEND */.Z3.DIVIDEND) {
        dataSource = [
            generateDateItem(),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Type"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.dividend_type
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Shares"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: (0,History_utils/* formatPrice */.T4)(dataTable.shares)
                })
            }, 
        ];
        if (dataTable.dividend_type.toUpperCase() === "CASH") {
            dataSource.splice(3, 0, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Dividend/Share"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.dividend_per_share
                })
            }, generateAmountItem("Dividend Amount (Rp)"));
        }
        if (dataTable.dividend_type.toUpperCase() === "STOCK") {
            dataSource.splice(3, 0, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Ratio (Old:New)"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.dividend_ratio
                })
            }, generateAmountItem("Dividend Amount (Shares)"));
        }
    }
    if (dataTable.command === types/* HistoryType.IPO */.Z3.IPO) {
        dataSource = [
            generateDateItem(),
            generateLotItem("Lot"),
            generatePriceItem("Price"),
            generateAmountItem("Total IPO Amount"), 
        ];
    }
    if (dataTable.command === types/* HistoryType.REFUND */.Z3.REFUND) {
        dataSource = [
            generateDateItem(),
            generateLotItem("Lot"),
            generatePriceItem("Price"),
            generateAmountItem("Refund Amount"), 
        ];
    }
    if (dataTable.command === types/* HistoryType.METERAI */.Z3.METERAI) {
        dataSource = [
            generateDateItem(),
            generateAmountItem("Biaya Meterai")
        ];
    }
    if (dataTable.command === types/* HistoryType.STAMP_DUTY_WITHDRAW */.Z3.STAMP_DUTY_WITHDRAW) {
        dataSource = [
            generateDateItem(),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Type"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: "Bea Materai Bibit"
                })
            },
            generateAmountItem("Withdrawal Amount"), 
        ];
    }
    if (dataTable.command === types/* HistoryType.SBN_WITHDRAW */.Z3.SBN_WITHDRAW) {
        var configStatusActive2 = configStatusDepositWithdrawal.find(function(e) {
            return e.status === dataTable.status.toUpperCase();
        });
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Status"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    color: configStatusActive2.color,
                    children: dataTable.status
                })
            },
            generateDateItem(),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Destination"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.bank_name
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Type"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: "SBN"
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Transaction ID"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.partner_reference
                })
            },
            generateAmountItem("Withdrawal Amount"), 
        ];
    }
    if ((dataTable === null || dataTable === void 0 ? void 0 : dataTable.command) === types/* HistoryType.CONVERSION */.Z3.CONVERSION) {
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Date"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,History_utils/* formatDate */.p6)(dataTable === null || dataTable === void 0 ? void 0 : dataTable.date)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Conversion Price"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: dataTable === null || dataTable === void 0 ? void 0 : dataTable.price
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Shares"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: dataTable === null || dataTable === void 0 ? void 0 : dataTable.shares
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "Conversion Amount"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: (0,History_utils/* formatPrice */.T4)(dataTable === null || dataTable === void 0 ? void 0 : dataTable.amount)
                })
            }, 
        ];
    }
    if (dataTable.command === types/* HistoryType.BUY_FR */.Z3.BUY_FR || dataTable.command === types/* HistoryType.REFUND_FR */.Z3.REFUND_FR) {
        var ref1, ref2, ref3;
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Tanggal Pembelian"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,History_utils/* formatDate */.p6)(dataTable.date)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Unit Pembelian"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: dataTable.shares
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Harga Beli (%)"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: dataTable === null || dataTable === void 0 ? void 0 : (ref1 = dataTable.bonds) === null || ref1 === void 0 ? void 0 : ref1.bonds_price
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Nilai Pembelian"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(dataTable.amount)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Kupon Penjual"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)((ref2 = dataTable.bonds) === null || ref2 === void 0 ? void 0 : ref2.accrued_interest, "exceptZero")
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Bea Meterai"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(dataTable === null || dataTable === void 0 ? void 0 : (ref3 = dataTable.bonds) === null || ref3 === void 0 ? void 0 : ref3.stamp_duty, "exceptZero")
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "Nominal Pembelian"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(dataTable.netamount)
                })
            }, 
        ];
    }
    if (dataTable.command === types/* HistoryType.SELL_FR */.Z3.SELL_FR) {
        var ref4, ref5, ref6;
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Tanggal Penjualan"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,History_utils/* formatDate */.p6)(dataTable.date)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Unit Penjualan"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: dataTable.shares
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Harga Jual (%)"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (ref4 = dataTable.bonds) === null || ref4 === void 0 ? void 0 : ref4.bonds_price
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Nilai Penjualan"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(dataTable.amount)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Kupon Berjalan"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(dataTable === null || dataTable === void 0 ? void 0 : (ref5 = dataTable.bonds) === null || ref5 === void 0 ? void 0 : ref5.accrued_interest_exclude_tax, "exceptZero")
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Pajak Obligasi\xa0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            component: InfoSvg/* default */.Z,
                            style: {
                                color: "#969696"
                            },
                            onClick: function() {
                                return openInfoModal(constants/* BondInfoType.BOND_TAX */.Im.BOND_TAX);
                            }
                        })
                    ]
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(dataTable.fee * -1, "exceptZero")
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Bea Meterai"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)((dataTable === null || dataTable === void 0 ? void 0 : (ref6 = dataTable.bonds) === null || ref6 === void 0 ? void 0 : ref6.stamp_duty) * -1, "exceptZero")
                })
            },
            Math.abs(dataTable.bonds.seller_coupon) > 0 ? {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(securities_styled/* Flex */.kC, {
                    align: "center",
                    style: {
                        gap: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Kupon Penjual\xa0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: InfoSvg/* default */.Z,
                                style: {
                                    color: "#969696"
                                },
                                onClick: function() {
                                    return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                }
                            })
                        ]
                    })
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(dataTable.bonds.seller_coupon, "exceptZero")
                })
            } : {},
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Nominal Diterima"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(dataTable.netamount)
                })
            }, 
        ];
    }
    if (types/* COUPONS.includes */.rs.includes(dataTable.command)) {
        var ref7;
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Tanggal Pencairan Kupon"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,History_utils/* formatDate */.p6)(dataTable.date)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Rate Kupon"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (ref7 = dataTable.bonds) === null || ref7 === void 0 ? void 0 : ref7.bonds_price
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Total Unit"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: dataTable.shares
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Nominal Kupon"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatCurrency */.xG)(String(dataTable.amount))
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Pajak"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        dataTable.fee !== 0 && "-",
                        (0,withdrawal_utils/* formatCurrency */.xG)(String(dataTable.fee))
                    ]
                })
            },
            dataTable.bonds.seller_coupon > 0 && {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(securities_styled/* Flex */.kC, {
                    align: "center",
                    style: {
                        gap: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Kupon Penjual"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: InfoSvg/* default */.Z,
                                style: {
                                    color: "#969696"
                                },
                                onClick: function() {
                                    return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                }
                            })
                        ]
                    })
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,withdrawal_utils/* formatCurrency */.xG)(String(dataTable.bonds.seller_coupon))
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "Kupon Diterima (Nett)"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: (0,withdrawal_utils/* formatCurrency */.xG)(String(dataTable.netamount))
                })
            }, 
        ];
    }
    if (dataTable.command === types/* HistoryType.DATA_FEE */.Z3.DATA_FEE) {
        dataSource = [
            generateDateItem(),
            generateAmountItem("Biaya Datafeed")
        ];
    }
    if (dataTable.command === types/* HistoryType.SBN_MATURITY_REDEMPTION */.Z3.SBN_MATURITY_REDEMPTION || dataTable.command === types/* HistoryType.SBN_EARLY_REDEMPTION */.Z3.SBN_EARLY_REDEMPTION) {
        dataSource = [
            generateDateItem(),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    family: "bold",
                    children: dataTable.command === types/* HistoryType.SBN_MATURITY_REDEMPTION */.Z3.SBN_MATURITY_REDEMPTION ? "Bond Redemption Amount" : "Early Redemption Amount"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    children: (0,History_utils/* formatPrice */.T4)(dataTable.netamount)
                })
            }, 
        ];
    }
    if (dataTable.command === types/* HistoryType.FR_MATURITY_REDEMPTION */.Z3.FR_MATURITY_REDEMPTION || dataTable.command === types/* HistoryType.BOND_REDEMPTION */.Z3.BOND_REDEMPTION) {
        var ref8 = generateRealizedValueConfig(dataTable.realized_amount), realizedColor = ref8.color, realizedTitle = ref8.title;
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Maturity Date"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: (0,History_utils/* formatDate */.p6)(dataTable.date)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Sell Amount (Rp)"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: (0,History_utils/* formatPrice */.T4)(dataTable.amount)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Sell Price (%)"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: "100.00%"
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Avg. Buy Price (%)"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: [
                        dataTable.price,
                        " %"
                    ]
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    as: "span",
                    children: [
                        "Pajak Keuntungan",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            as: "span",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: onClickFee,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: InfoSvg/* default */.Z,
                                style: {
                                    fontSize: 16,
                                    color: "#969696",
                                    marginLeft: 4
                                }
                            })
                        })
                    ]
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: (0,History_utils/* formatPrice */.T4)(dataTable.fee, false)
                })
            },
            generateAmountItem("Total Amount"),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    family: "bold",
                    children: realizedTitle
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    color: realizedColor,
                    children: (0,History_utils/* getRealizedPnLText */.nE)(dataTable, 2)
                })
            }, 
        ];
    }
    if (dataTable.command === types/* HistoryType.IFA_WITHDRAW */.Z3.IFA_WITHDRAW) {
        var configStatusActive3 = configStatusDepositWithdrawal.find(function(e) {
            return e.status === dataTable.status.toUpperCase();
        });
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Status"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    color: configStatusActive3.color,
                    children: dataTable.status
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Transaction ID"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    style: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        dataTable.label,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            width: "14",
                            height: "13",
                            src: "icon/copy-transaction-id.svg",
                            style: {
                                marginLeft: 4,
                                cursor: "pointer"
                            },
                            onClick: function() {
                                navigator.clipboard.writeText(dataTable.label);
                                (0,AlertMessage/* default */.Z)({
                                    content: "Nomor Transaction ID berhasil disalin",
                                    alertType: "snackbar",
                                    messageType: "success",
                                    hasCloseIcon: true
                                });
                            }
                        })
                    ]
                })
            },
            generateDateItem(),
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Type"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: "Advisory Fee"
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Destination"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.bank_name
                })
            },
            generateAmountItem("Withdrawal Amount"), 
        ];
    }
    if (types/* TransferCash.includes */.Rf.includes(dataTable.command)) {
        var ref9, ref10, ref11, ref12;
        dataSource = [
            generateDateItem(),
            generateItem("Source", (ref9 = dataTable.move_stock_cash) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.source) === null || ref10 === void 0 ? void 0 : ref10.name),
            generateItem("Destination", (ref11 = dataTable.move_stock_cash) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.destination) === null || ref12 === void 0 ? void 0 : ref12.name),
            generateAmountItem("Transfer Amount"), 
        ];
        if (types/* ShowTransferStatus.includes */.cX.includes(dataTable.status)) {
            dataSource.unshift(generateStatus(dataTable.status.toUpperCase()));
        }
    }
    if (types/* TransferStock.includes */.fs.includes(dataTable.command)) {
        var ref13, ref14, ref15, ref16;
        dataSource = [
            generateDateItem(),
            generateLotItem("Lot"),
            generatePriceItem("Average Price", true),
            generateItem("Source", (ref13 = dataTable.move_stock_cash) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.source) === null || ref14 === void 0 ? void 0 : ref14.name),
            generateItem("Destination", (ref15 = dataTable.move_stock_cash) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.destination) === null || ref16 === void 0 ? void 0 : ref16.name),
            generateAmountItem("Amount", false)
        ];
        if (types/* ShowTransferStatus.includes */.cX.includes(dataTable.status)) {
            dataSource.unshift(generateStatus(dataTable.status.toUpperCase()));
        }
    }
    if (dataTable.command === types/* HistoryType.CAPITAL_REDUCTION */.Z3.CAPITAL_REDUCTION) {
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Date"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.date
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    family: "bold",
                    children: "Capital Reduction Amount (Rp)"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    children: (0,History_utils/* formatPrice */.T4)(dataTable.netamount)
                })
            }, 
        ];
    }
    if (dataTable.command === types/* HistoryType.SWEEP_IN */.Z3.SWEEP_IN || dataTable.command === types/* HistoryType.SWEEP_OUT */.Z3.SWEEP_OUT) {
        var amountLabel = dataTable.command === types/* HistoryType.SWEEP_IN */.Z3.SWEEP_IN ? "Sweep In Amount" : "Sweep Out Amount";
        dataSource = [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    children: "Date"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    children: dataTable.date
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    family: "bold",
                    children: amountLabel
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "div",
                    align: "right",
                    family: "bold",
                    children: (0,History_utils/* formatPrice */.T4)(dataTable.netamount)
                })
            }, 
        ];
    }
    return dataSource;
};
/* harmony default export */ var DetailTableData = ((/* unused pure expression or super */ null && (getDetailTableData)));

// EXTERNAL MODULE: ./src/features/trade/components/DetailModal/styled.ts
var DetailModal_styled = __webpack_require__(75818);
;// CONCATENATED MODULE: ./src/features/trade/components/History/HistoryFeeModal.tsx



var HistoryFeeModal = function(param) {
    var visible = param.visible, onCancel = param.onCancel, _title = param.title, title = _title === void 0 ? "Pajak Keuntungan" : _title, _description = param.description, description = _description === void 0 ? "Pajak Keuntungan adalah pajak yang dikenakan atas capital gain yang diterima dari penjualan FR bonds disaat bond maturity (10%)." : _description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal_styled/* Modal */.u_, {
        visible: visible,
        onCancel: onCancel,
        centered: true,
        width: 520,
        "data-cy": "trade-detail-modal-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* HeaderWrapper */.Pz, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "center",
                    family: "bold",
                    size: "20px",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* ContentWrapper */.vs, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: description
                })
            })
        ]
    });
};
/* harmony default export */ var History_HistoryFeeModal = (HistoryFeeModal);

// EXTERNAL MODULE: ./src/features/trade/components/History/styled.ts
var History_styled = __webpack_require__(67744);
// EXTERNAL MODULE: ./src/features/trade/components/Portfolio/PnLCurrency.tsx
var PnLCurrency = __webpack_require__(32978);
;// CONCATENATED MODULE: ./src/features/trade/components/History/HistoryModal.tsx



















var HistoryModalTypeProps;
(function(HistoryModalTypeProps) {
    HistoryModalTypeProps["DETAIL"] = "DETAIL";
    HistoryModalTypeProps["FEE"] = "FEE";
})(HistoryModalTypeProps || (HistoryModalTypeProps = {}));
var HistoryModal = function(param) {
    var record = param.record, onCancel = param.onCancel, onCompanyClick = param.onCompanyClick, visible = param.visible;
    var ref, ref1, ref2, ref3, ref4;
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    var ref5 = (0,react.useState)(null), currentRecord = ref5[0], setCurrentRecord = ref5[1];
    var ref6 = (0,react.useState)(HistoryModalTypeProps.DETAIL), modalType = ref6[0], setModalType = ref6[1];
    var handleOpenFeeModal = function() {
        setModalType(HistoryModalTypeProps.FEE);
    };
    (0,react.useEffect)(function() {
        if (record === null || record === void 0 ? void 0 : record.display_as) {
            var dataSource = getDetailTableData(record, handleOpenFeeModal, openInfoModal);
            setCurrentRecord(dataSource);
        }
    }, [
        record
    ]);
    var onCancelFull = function() {
        setCurrentRecord(null);
        onCancel();
    };
    var isShowForcellBadge = (record === null || record === void 0 ? void 0 : record.is_day_trade) && (record === null || record === void 0 ? void 0 : record.command) === types/* HistoryType.FORCED_SELL_DAY_TRADE */.Z3.FORCED_SELL_DAY_TRADE;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_DetailModal/* default */.Z, {
                visible: visible && Boolean(record) && modalType === HistoryModalTypeProps.DETAIL,
                onCancel: onCancelFull,
                title: record === null || record === void 0 ? void 0 : record.display_as,
                symbol: record === null || record === void 0 ? void 0 : record.symbol,
                showPrice: false,
                isBonds: types/* FR_BONDS.includes */.a0.includes(record === null || record === void 0 ? void 0 : record.command),
                isRedemption: types/* REDEMPTIONS.includes */.li.includes(record === null || record === void 0 ? void 0 : record.command),
                bondsName: record === null || record === void 0 ? void 0 : (ref = record.bonds) === null || ref === void 0 ? void 0 : ref.product_name,
                onCompanyClick: onCompanyClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isShowForcellBadge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {
                            label: "FORCED SELL",
                            timeOpen: "".concat(record === null || record === void 0 ? void 0 : record.date, " ").concat(record === null || record === void 0 ? void 0 : record.time),
                            forcedSell: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(History_styled/* HistoryModalInfoTable */.AJ, {
                        dataSource: currentRecord
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: (record === null || record === void 0 ? void 0 : record.command) === types/* HistoryType.LATE_FEE */.Z3.LATE_FEE,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(History_styled/* HistoryModalInfoTable */.AJ, {
                            dataSource: [
                                {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "span",
                                        children: "Date"
                                    }),
                                    value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "div",
                                        align: "right",
                                        children: record === null || record === void 0 ? void 0 : record.date
                                    })
                                },
                                {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "span",
                                        family: "bold",
                                        children: "Late Fee"
                                    }),
                                    value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "div",
                                        align: "right",
                                        family: "bold",
                                        children: (0,History_utils/* formatCeilToDecimals */.qx)(record === null || record === void 0 ? void 0 : record.netamount, "-")
                                    })
                                }, 
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                        condition: (record === null || record === void 0 ? void 0 : record.command) === types/* HistoryType.SELL_FR */.Z3.SELL_FR,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* BorderedContainer */.a$, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapsible/* default */.Z, {
                                    header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        justify: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                direction: "column",
                                                align: "start",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    "data-cy": "bond-total-pl-label",
                                                    mr: "4px",
                                                    children: "P&L (Nett)"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                dataCy: "bond-total-pl-content",
                                                amount: record === null || record === void 0 ? void 0 : record.realized_amount,
                                                percentage: record === null || record === void 0 ? void 0 : record.realized_percentage,
                                                isMultiline: true,
                                                family: "bold"
                                            })
                                        ]
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            align: "center",
                                            justify: "space-between",
                                            py: "8px",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    align: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            "data-cy": "bond-accrued-interest-label",
                                                            mr: "4px",
                                                            children: "Kupon Berjalan (Nett)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            component: InfoSvg/* default */.Z,
                                                            style: {
                                                                color: "#969696"
                                                            },
                                                            onClick: function() {
                                                                return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST */.Im.ACCRUED_INTEREST);
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                    dataCy: "bond-accrued-interest-content",
                                                    amount: record === null || record === void 0 ? void 0 : (ref1 = record.bonds) === null || ref1 === void 0 ? void 0 : ref1.accrued_interest_nett
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            align: "center",
                                            justify: "space-between",
                                            py: "8px",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                    align: "center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        "data-cy": "bond-capital-gain-loss-label",
                                                        mr: "4px",
                                                        children: "Capital Gain / Loss (Nett)"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                    dataCy: "bond-capital-gain-loss-content",
                                                    amount: record === null || record === void 0 ? void 0 : (ref2 = record.bonds) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.capital_gain_loss) === null || ref3 === void 0 ? void 0 : ref3.amount_nett
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* BorderedContainer */.a$, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapsible/* default */.Z, {
                                    header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        justify: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                direction: "column",
                                                align: "start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        align: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            "data-cy": "bond-total-pl-label",
                                                            mr: "4px",
                                                            children: "Total Keuntungan (Nett)"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        size: "12px",
                                                        color: "#B5B5B5",
                                                        children: "Selama Investasi"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                dataCy: "bond-total-pl-content",
                                                amount: record === null || record === void 0 ? void 0 : record.bonds.total_realized_amount,
                                                percentage: record === null || record === void 0 ? void 0 : record.bonds.total_realized_amount_percentage,
                                                isMultiline: true,
                                                family: "bold"
                                            })
                                        ]
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            align: "center",
                                            justify: "space-between",
                                            py: "8px",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    align: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            "data-cy": "bond-accrued-interest-label",
                                                            mr: "4px",
                                                            children: "Total Kupon Harian (Nett)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                            component: InfoSvg/* default */.Z,
                                                            style: {
                                                                color: "#969696"
                                                            },
                                                            onClick: function() {
                                                                return openInfoModal(constants/* BondInfoType.TOTAL_DAILY_COUPON */.Im.TOTAL_DAILY_COUPON);
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                    dataCy: "bond-accrued-interest-content",
                                                    amount: record === null || record === void 0 ? void 0 : record.bonds.daily_accrued_interest
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            align: "center",
                                            justify: "space-between",
                                            py: "8px",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                    align: "center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        "data-cy": "bond-capital-gain-loss-label",
                                                        mr: "4px",
                                                        children: "Capital Gain / Loss (Nett)"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                    dataCy: "bond-capital-gain-loss-content",
                                                    amount: (ref4 = record === null || record === void 0 ? void 0 : record.bonds.capital_gain_loss) === null || ref4 === void 0 ? void 0 : ref4.amount_nett
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(History_HistoryFeeModal, {
                visible: visible && Boolean(record) && modalType === HistoryModalTypeProps.FEE,
                onCancel: function() {
                    return setModalType(HistoryModalTypeProps.DETAIL);
                }
            })
        ]
    });
};
/* harmony default export */ var History_HistoryModal = ((/* unused pure expression or super */ null && (DetailModal)));


/***/ }),

/***/ 11481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IA": function() { return /* binding */ middleColumns; },
/* harmony export */   "Sr": function() { return /* binding */ realizedColumns; },
/* harmony export */   "TF": function() { return /* binding */ middleColumnsBonds; },
/* harmony export */   "bo": function() { return /* binding */ allColumns; }
/* harmony export */ });
/* unused harmony export MounthlySeparator */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62974);
/* harmony import */ var features_day_trade_components_Badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21548);
/* harmony import */ var global_Common_If__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3897);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36675);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67744);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74380);











var MounthlySeparator = function(param) {
    var groupDate = param.groupDate, groupRealizedGain = param.groupRealizedGain;
    var isRealizedGainHasValueNumber = typeof groupRealizedGain === "number";
    var colorIndicator = "#858585";
    if (isRealizedGainHasValueNumber) {
        if (groupRealizedGain > 0) {
            colorIndicator = _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary;
        }
        if (groupRealizedGain < 0) {
            colorIndicator = _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].sunsetOrange */ .Z.sunsetOrange;
        }
    }
    var monthlyRealizedAmount = (0,utils_number__WEBPACK_IMPORTED_MODULE_4__/* .roundNumber */ .QV)(groupRealizedGain, "0,0");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        justify: "space-between",
        align: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                size: "14px",
                family: "medium",
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray,
                children: groupDate
            }),
            isRealizedGainHasValueNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                size: "14px",
                family: "medium",
                color: colorIndicator,
                children: "".concat((0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .addPlusMinusIndicator */ .Rz)(monthlyRealizedAmount)).concat((0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .addPrefixAfterPlusMinusNotation */ .lG)(monthlyRealizedAmount))
            })
        ]
    });
};
var middleColumns = [
    {
        key: "lot",
        title: "Lot Done",
        dataIndex: "lot",
        width: "14%",
        render: function(lot, dataObject) {
            var isRedemption = _types__WEBPACK_IMPORTED_MODULE_9__/* .REDEMPTIONS.includes */ .li.includes(dataObject.command);
            var isBonds = _types__WEBPACK_IMPORTED_MODULE_9__/* .FR_BONDS.includes */ .a0.includes(dataObject.command);
            if (isBonds) {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(lot, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    align: "right",
                    children: dataObject.shares
                }));
            }
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(lot, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: lot === 0 || isRedemption ? "-" : lot
            }));
        }
    },
    {
        key: "price",
        title: "Price",
        dataIndex: "price",
        className: "td-mobile history-price",
        width: "13%",
        render: function(text, dataObject) {
            var isBondsFR = _types__WEBPACK_IMPORTED_MODULE_9__/* .FR_BONDS.includes */ .a0.includes(dataObject.command);
            var isRedemption = _types__WEBPACK_IMPORTED_MODULE_9__/* .REDEMPTIONS.includes */ .li.includes(dataObject.command);
            var isCoupon = _types__WEBPACK_IMPORTED_MODULE_9__/* .COUPONS.includes */ .rs.includes(dataObject.command);
            if (isCoupon) {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    align: "right",
                    children: "-"
                }));
            }
            if (isRedemption) {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    align: "right",
                    children: "100.00%"
                }));
            }
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: isBondsFR ? (0,utils_number__WEBPACK_IMPORTED_MODULE_4__/* .formatPercentage */ .rl)(text) : (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatPriceRoundDown */ .Dq)(text)
            }));
        }
    },
    {
        key: "amount",
        title: "Amount Done",
        dataIndex: "amount",
        className: "td-mobile history-amount-done",
        width: "15%",
        render: function(text, dataObject) {
            var isTransfer = _types__WEBPACK_IMPORTED_MODULE_9__/* .TRANSFERS.includes */ .Dt.includes(dataObject.command);
            if (isTransfer) {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    align: "right",
                    children: "-"
                }));
            }
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatPrice */ .T4)(text)
            }));
        }
    },
    {
        key: "fee",
        title: "Total Fee",
        dataIndex: "fee",
        width: "15%",
        render: function(text, dataObject) {
            // isSellFR, isCouponFR, isCouponKAEF01CB, isCouponSBN
            var couponCommands = [
                _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.SELL_FR */ .Z3.SELL_FR,
                _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.COUPON_FR */ .Z3.COUPON_FR,
                _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.COUPON_KAEF01CB */ .Z3.COUPON_KAEF01CB,
                _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.COUPON_SBN */ .Z3.COUPON_SBN, 
            ];
            var showMinusSign = couponCommands.includes(dataObject.command);
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: [
                    showMinusSign && text !== 0 && "-",
                    (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatPrice */ .T4)(text, !showMinusSign)
                ]
            }));
        }
    },
    {
        key: "netamount",
        title: "Net Amount",
        dataIndex: "netamount",
        width: "15%",
        render: function(text, dataObject) {
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: dataObject.command === _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.LATE_FEE */ .Z3.LATE_FEE ? (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatCeilToDecimals */ .qx)(text, "-") : (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatPrice */ .T4)(text)
            }));
        }
    }, 
];
var middleColumnsBonds = [
    {
        key: "price",
        title: "Price",
        dataIndex: "price",
        className: "td-mobile history-price",
        width: "13%",
        render: function(text, dataObject) {
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: (0,utils_number__WEBPACK_IMPORTED_MODULE_4__/* .formatPercentage */ .rl)(text)
            }));
        }
    },
    {
        key: "netamount",
        title: "Total Amount",
        dataIndex: "netamount",
        className: "td-mobile history-amount-done",
        width: "15%",
        render: function(text, dataObject) {
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatPrice */ .T4)(text)
            }));
        }
    }, 
];
var allColumns = [
    {
        key: "display_as",
        title: "Ordered Items",
        dataIndex: "display_as",
        className: "td-mobile history-order-item",
        width: "13%",
        render: function(text, dataObject) {
            var isShowForcellBadge = dataObject.is_day_trade && dataObject.command === _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.FORCED_SELL_DAY_TRADE */ .Z3.FORCED_SELL_DAY_TRADE;
            if (dataObject.groupDate) {
                return {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MounthlySeparator, {
                        groupDate: dataObject.groupDate
                    }),
                    props: {
                        colSpan: 7
                    }
                };
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        color: dataObject.status_color_code,
                        as: "span",
                        family: "bold",
                        children: [
                            text,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Common_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        condition: dataObject.label,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_8__/* .SellBadge */ .tY, {
                            family: "bold",
                            children: dataObject.label.toUpperCase()
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Common_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        condition: isShowForcellBadge,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(features_day_trade_components_Badge__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            label: "FORCED SELL",
                            isDayTrade: true
                        })
                    })
                ]
            });
        }
    }, 
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(middleColumns), [
    {
        key: "date",
        title: "Date",
        dataIndex: "date",
        className: "td-mobile history-date normal",
        width: "15%",
        render: function(text, dataObject) {
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatDate */ .p6)(text)
            }));
        }
    }, 
]);
var realizedColumns = [
    {
        key: "symbol",
        title: "Ordered Items",
        dataIndex: "symbol",
        className: "td-mobile history-order-item realized",
        render: function(text, dataObject) {
            if (dataObject.groupDate) {
                return {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MounthlySeparator, {
                        groupDate: dataObject.groupDate,
                        groupRealizedGain: dataObject.groupRealizedGain
                    }),
                    props: {
                        colSpan: 8
                    }
                };
            }
            var isBonds = _types__WEBPACK_IMPORTED_MODULE_9__/* .BONDS.includes */ .Mu.includes(dataObject.command);
            var isDividend = dataObject.command === _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.DIVIDEND */ .Z3.DIVIDEND;
            var isCapitalReduction = dataObject.command === _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.CAPITAL_REDUCTION */ .Z3.CAPITAL_REDUCTION;
            var isRedemtion = _types__WEBPACK_IMPORTED_MODULE_9__/* .REDEMPTIONS.includes */ .li.includes(dataObject.command);
            var useDisplayAs = isDividend || isBonds || isRedemtion || isCapitalReduction;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                family: "bold",
                children: useDisplayAs ? dataObject.display_as : text
            });
        }
    },
    {
        key: "lot",
        title: "Lot Done",
        dataIndex: "lot",
        className: "history-lot-done realized",
        render: function(lot, dataObject) {
            var isBonds = _types__WEBPACK_IMPORTED_MODULE_9__/* .BONDS.includes */ .Mu.includes(dataObject.command);
            var isRedemption = _types__WEBPACK_IMPORTED_MODULE_9__/* .REDEMPTIONS.includes */ .li.includes(dataObject.command);
            if (isBonds) {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(lot, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    align: "right",
                    children: dataObject.shares === 0 ? "-" : dataObject.shares
                }));
            }
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(lot, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: lot === 0 || isBonds || isRedemption ? "-" : lot
            }));
        }
    },
    {
        key: "price",
        title: "Price",
        dataIndex: "price",
        className: "td-mobile history-price",
        render: function(text, dataObject) {
            var ref;
            var isBondsFR = _types__WEBPACK_IMPORTED_MODULE_9__/* .FR_BONDS.includes */ .a0.includes(dataObject.command);
            var isRedemption = _types__WEBPACK_IMPORTED_MODULE_9__/* .REDEMPTIONS.includes */ .li.includes(dataObject.command);
            var isCoupon = _types__WEBPACK_IMPORTED_MODULE_9__/* .COUPONS.includes */ .rs.includes(dataObject.command);
            if (isCoupon) {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    align: "right",
                    children: "-"
                }));
            }
            if (isRedemption) {
                return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    align: "right",
                    children: "100.00%"
                }));
            }
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatPriceRoundDown */ .Dq)(isBondsFR ? dataObject === null || dataObject === void 0 ? void 0 : (ref = dataObject.bonds) === null || ref === void 0 ? void 0 : ref.bonds_price : text)
            }));
        }
    },
    {
        key: "amount",
        title: "Amount Done",
        dataIndex: "amount",
        className: "td-mobile history-amount-done",
        render: function(text, dataObject) {
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatPrice */ .T4)(text)
            }));
        }
    },
    {
        key: "fee",
        title: "Total Fee",
        dataIndex: "fee",
        render: function(text, dataObject) {
            // isSellFR, isCouponFR, isCouponKAEF01CB, isCouponSBN
            var couponCommands = [
                _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.SELL_FR */ .Z3.SELL_FR,
                _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.COUPON_FR */ .Z3.COUPON_FR,
                _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.COUPON_KAEF01CB */ .Z3.COUPON_KAEF01CB,
                _types__WEBPACK_IMPORTED_MODULE_9__/* .HistoryType.COUPON_SBN */ .Z3.COUPON_SBN, 
            ];
            var showMinusSign = couponCommands.includes(dataObject.command);
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: [
                    showMinusSign && text !== 0 && "-",
                    (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatPrice */ .T4)(text, !showMinusSign)
                ]
            }));
        }
    },
    {
        key: "netamount",
        title: "Net Amount",
        dataIndex: "netamount",
        render: function(text, dataObject) {
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatPrice */ .T4)(text)
            }));
        }
    },
    {
        key: "realized_amount",
        title: "Realized P&L",
        dataIndex: "realized_amount",
        render: function(text, dataObject) {
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                color: dataObject.realized_color_code ? dataObject.realized_color_code.light_mode : "#333333",
                align: "right",
                children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .getRealizedPnLText */ .nE)(dataObject)
            }));
        }
    },
    {
        key: "date",
        title: "Date",
        dataIndex: "date",
        className: "td-mobile history-date normal",
        render: function(text, dataObject) {
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .renderTableRowContent */ .YK)(text, dataObject, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "right",
                children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .formatDate */ .p6)(text)
            }));
        }
    }, 
];


/***/ }),

/***/ 67744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ HistoryModalInfoTable; },
/* harmony export */   "PZ": function() { return /* binding */ CloseButton; },
/* harmony export */   "Ph": function() { return /* binding */ Select; },
/* harmony export */   "eI": function() { return /* binding */ SelectContainer; },
/* harmony export */   "ol": function() { return /* binding */ Search; },
/* harmony export */   "pJ": function() { return /* binding */ RealizedBoxContainer; },
/* harmony export */   "tR": function() { return /* binding */ RealizedTooltipBox; },
/* harmony export */   "tY": function() { return /* binding */ SellBadge; },
/* harmony export */   "uW": function() { return /* binding */ HistoryTable; },
/* harmony export */   "xW": function() { return /* binding */ RealizedBox; }
/* harmony export */ });
/* unused harmony exports Autocomplete, DatepickerContainer, Datepicker, Button, PopoverContentContainer, SellFRTooltip */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_DatePicker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70420);
/* harmony import */ var _deprecated_ui_common_Autocomplete__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94526);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_widget_Select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48469);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22147);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19521);
/* harmony import */ var _DetailModal_InfoTable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51981);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  width: 100%;\n  cursor: pointer;\n\n  .ant-spin-nested-loading,\n  .ant-spin-container,\n  .ant-table-empty,\n  .ant-table-container,\n  .ant-table-content {\n    height: 100%;\n  }\n\n  & .ant-table-content > table {\n    height: 100%;\n  }\n\n  .ant-table-thead > tr > th {\n    height: 17px;\n    font-size: 14px;\n    border-bottom: 1px solid ",
        ";\n    background: transparent;\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td:not(.td-mobile) {\n    display: none;\n  }\n\n  .group-date-row {\n    background: #f6f6f6;\n  }\n\n  .ant-table-content {\n    overflow-x: auto;\n  }\n\n  @media ",
        " {\n    .history-order-item {\n      white-space: nowrap;\n    }\n\n    .ant-table-thead > tr > th:not(:first-child) {\n      text-align: right;\n    }\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td:not(.td-mobile) {\n      display: table-cell;\n    }\n\n    .ant-table-tbody > tr > td {\n      padding: 8px 15px;\n      height: 40px;\n      border-bottom: 0;\n    }\n\n    .ant-table-tbody > tr > .td-mobile:first-child,\n    .ant-table-tbody > tr > .td-mobile {\n      display: table-cell;\n      width: inherit;\n      border-width: 1px;\n    }\n  }\n\n  &.hidden-body {\n    .ant-table-tbody {\n      display: none;\n    }\n  }\n\n  &.modal-history {\n    .ant-table-thead {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 2px;\n  padding: 0 6px 0 16px;\n  width: 100%;\n\n  &:not(.ant-input-affix-wrapper-disabled):hover {\n    border-color: ",
        ";\n  }\n\n  @media ",
        " {\n    width: 335px !important;\n  }\n\n  input {\n    font-size: 14px;\n    color: ",
        ";\n    font-weight: 400;\n\n    &::placeholder {\n      color: ",
        ";\n    }\n  }\n\n  .ant-input-prefix {\n    margin-right: 10px;\n  }\n\n  .icon-toolbar_information {\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  &.has-error {\n    border: 1px solid ",
        ";\n    &:hover {\n      border: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-clear {\n    opacity: 1;\n  }\n  &.ant-select-status-error {\n    ",
        " {\n      border-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 50%;\n  height: 32px;\n  input {\n    font-size: 12px;\n\n    &:hover {\n      border: none !important;\n    }\n  }\n\n  &:hover {\n    border: none !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 80px;\n  border-radius: 4px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 3px 5px;\n  border: 0.8px solid ",
        ";\n  border-radius: 2px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 12px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  min-width: 280px;\n  position: relative;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: -2%;\n  left: 102%;\n  width: 375px;\n  height: auto;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  z-index: 999;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-selector {\n    border-radius: 4px !important;\n  }\n\n  .ant-select-selector {\n    .ant-select-selection-item {\n      .select-label {\n        color: ",
        ";\n        font-family: var(--font-regular);\n        display: inline;\n        margin: 0;\n        background: transparent;\n        padding: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: transparent;\n  border: 1px solid ",
        ";\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  cursor: pointer;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-dropdown {\n    width: auto !important;\n\n    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n      background: ",
        ";\n    }\n\n    .ant-select-item-option-active {\n      background: ",
        ";\n      .ant-select-item-option-content {\n        text-overflow: unset;\n        span {\n          color: ",
        "!important;\n        }\n      }\n    }\n  }\n\n  .ant-picker-date-panel {\n    width: 280px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: 20px;\n\n  & h3 {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 22px;\n    color: ",
        ";\n  }\n\n  & p {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 19px;\n    color: ",
        ";\n    max-width: 335px;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 14px;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  background-color: #f2f1fe;\n\n  & p {\n    margin-bottom: 0;\n    margin-left: 16px;\n    font-size: 12px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  row-gap: 8px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}












var HistoryTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7065803e-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_8__/* ["default"].mobileL */ .Z.mobileL);
var Search = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7065803e-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_8__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].nightRider */ .Z.nightRider, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].sunsetOrange */ .Z.sunsetOrange);
var Autocomplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_deprecated_ui_common_Autocomplete__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7065803e-2"
})(_templateObject2(), Search, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].sunsetOrange */ .Z.sunsetOrange);
var DatepickerContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7065803e-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].primary */ .Z.primary);
var Datepicker = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_deprecated_ui_common_DatePicker__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7065803e-4"
})(_templateObject4());
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7065803e-5"
})(_templateObject5());
var SellBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    ml: "10px",
    family: "bold",
    size: "8px",
    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].highgray */ .Z.highgray
}).withConfig({
    componentId: "sc-7065803e-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].downgray */ .Z.downgray);
var RealizedBoxContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    padding: "16px",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-7065803e-7"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].gainsboro */ .Z.gainsboro);
var RealizedBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    direction: "column",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-7065803e-8"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].gainsboro */ .Z.gainsboro);
var RealizedTooltipBox = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7065803e-9"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].gainsboro */ .Z.gainsboro);
var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_deprecated_ui_widget_Select__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7065803e-10"
})(_templateObject10(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].nightRider */ .Z.nightRider);
var CloseButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    as: "button",
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-7065803e-11"
})(_templateObject11(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].dimGray */ .Z.dimGray);
var SelectContainer = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7065803e-12"
})(_templateObject12(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].component */ .Z.component, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].whisper */ .Z.whisper, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].primary */ .Z.primary);
var PopoverContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7065803e-13"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].highempahis */ .Z.highempahis);
var SellFRTooltip = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7065803e-14"
})(_templateObject14(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_9__/* ["default"].highempahis */ .Z.highempahis);
var HistoryModalInfoTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_DetailModal_InfoTable__WEBPACK_IMPORTED_MODULE_10__/* .InfoTable */ .C).withConfig({
    componentId: "sc-7065803e-15"
})(_templateObject15());


/***/ }),

/***/ 74380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ TRANSFERS; },
/* harmony export */   "K$": function() { return /* binding */ RealizedFilterEnum; },
/* harmony export */   "Mu": function() { return /* binding */ BONDS; },
/* harmony export */   "Rf": function() { return /* binding */ TransferCash; },
/* harmony export */   "Z3": function() { return /* binding */ HistoryType; },
/* harmony export */   "a0": function() { return /* binding */ FR_BONDS; },
/* harmony export */   "cX": function() { return /* binding */ ShowTransferStatus; },
/* harmony export */   "cy": function() { return /* binding */ HistoryTab; },
/* harmony export */   "fs": function() { return /* binding */ TransferStock; },
/* harmony export */   "li": function() { return /* binding */ REDEMPTIONS; },
/* harmony export */   "rs": function() { return /* binding */ COUPONS; }
/* harmony export */ });
/* unused harmony export HistoryStatus */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36305);

var HistoryType;
(function(HistoryType) {
    HistoryType["BUY"] = "BUY";
    HistoryType["SELL"] = "SELL";
    HistoryType["FORCED_SELL_DAY_TRADE"] = "FORCE SELL DAY TRADE";
    HistoryType["DEPOSIT"] = "DEPOSIT";
    HistoryType["CASHBACK_STOCKBIT"] = "CASHBACK STOCKBIT";
    HistoryType["CASHBACK_BROKER_FEE"] = "CASHBACK BROKER FEE";
    HistoryType["WITHDRAW"] = "WITHDRAW";
    HistoryType["EXERCISE"] = "EXC";
    HistoryType["DIVIDEND"] = "DIV";
    HistoryType["IPO"] = "IPO";
    HistoryType["REFUND"] = "REFUND";
    HistoryType["METERAI"] = "METERAI";
    HistoryType["STAMP_DUTY_WITHDRAW"] = "STAMP_DUTY_WITHDRAW";
    HistoryType["CONVERSION"] = "CONVERSION";
    HistoryType["BUY_FR"] = "BUY_FR";
    HistoryType["SELL_FR"] = "SELL_FR";
    HistoryType["REFUND_FR"] = "REFUND_FR";
    HistoryType["COUPON_FR"] = "COUPON_FR";
    HistoryType["COUPON_KAEF01CB"] = "COUPON_KAEF01CB";
    HistoryType["COUPON_SBN"] = "COUPON_SBN";
    HistoryType["DATA_FEE"] = "DATA FEE";
    HistoryType["LATE_FEE"] = "LATE FEE";
    HistoryType["SBN_EARLY_REDEMPTION"] = "SBN_EARLY_REDEMPTION";
    HistoryType["SBN_MATURITY_REDEMPTION"] = "SBN_MATURITY_REDEMPTION";
    HistoryType["SBN_WITHDRAW"] = "SBN_WITHDRAW";
    HistoryType["FR_MATURITY_REDEMPTION"] = "FR_MATURITY_REDEMPTION";
    HistoryType["BOND_REDEMPTION"] = "BOND_REDEMPTION";
    HistoryType["IFA_WITHDRAW"] = "IFA_WITHDRAW";
    HistoryType["INTRA_MOVE_CASH"] = "INTRA_MOVE_CASH";
    HistoryType["INTRA_MOVE_CASH_INCREASE"] = "INTRA_MOVE_CASH_INCREASE";
    HistoryType["INTRA_MOVE_STOCK"] = "INTRA_MOVE_STOCK";
    HistoryType["INTRA_MOVE_STOCK_INCREASE"] = "INTRA_MOVE_STOCK_INCREASE";
    HistoryType["CAPITAL_REDUCTION"] = "CAPITAL_REDUCTION";
    HistoryType["SWEEP_IN"] = "SWEEP_IN";
    HistoryType["SWEEP_OUT"] = "SWEEP_OUT";
})(HistoryType || (HistoryType = {}));
var FR_BONDS = [
    HistoryType.BUY_FR,
    HistoryType.SELL_FR,
    HistoryType.REFUND_FR,
    HistoryType.COUPON_FR, 
];
var BONDS = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FR_BONDS).concat([
    HistoryType.COUPON_KAEF01CB,
    HistoryType.COUPON_SBN, 
]);
var COUPONS = [
    HistoryType.COUPON_FR,
    HistoryType.COUPON_KAEF01CB,
    HistoryType.COUPON_SBN, 
];
var REDEMPTIONS = [
    HistoryType.SBN_EARLY_REDEMPTION,
    HistoryType.SBN_MATURITY_REDEMPTION,
    HistoryType.FR_MATURITY_REDEMPTION,
    HistoryType.BOND_REDEMPTION, 
];
var TRANSFERS = [
    HistoryType.INTRA_MOVE_CASH,
    HistoryType.INTRA_MOVE_CASH_INCREASE,
    HistoryType.INTRA_MOVE_STOCK,
    HistoryType.INTRA_MOVE_STOCK_INCREASE, 
];
var HistoryTab;
(function(HistoryTab) {
    HistoryTab["ALL"] = "all";
    HistoryTab["REALIZED"] = "realized";
})(HistoryTab || (HistoryTab = {}));
var RealizedFilterEnum;
(function(RealizedFilterEnum) {
    RealizedFilterEnum["STOCK_REALIZED"] = "stockrealized";
    RealizedFilterEnum["STOCK_DIVIDEND"] = "dividendrealized";
    RealizedFilterEnum["BOND_REALIZED"] = "bondrealized";
    RealizedFilterEnum["BOND_COUPON"] = "couponrealized";
})(RealizedFilterEnum || (RealizedFilterEnum = {}));
var HistoryStatus;
(function(HistoryStatus) {
    HistoryStatus["SUCCESS"] = "Success";
    HistoryStatus["PENDING"] = "Pending";
    HistoryStatus["FAILED"] = "Failed";
})(HistoryStatus || (HistoryStatus = {}));
var TransferCash = [
    HistoryType.INTRA_MOVE_CASH,
    HistoryType.INTRA_MOVE_CASH_INCREASE, 
];
var TransferStock = [
    HistoryType.INTRA_MOVE_STOCK,
    HistoryType.INTRA_MOVE_STOCK_INCREASE, 
];
var ShowTransferStatus = [
    HistoryStatus.SUCCESS,
    HistoryStatus.FAILED, 
];


/***/ }),

/***/ 36675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dq": function() { return /* binding */ formatPriceRoundDown; },
/* harmony export */   "Rz": function() { return /* binding */ addPlusMinusIndicator; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "YK": function() { return /* binding */ renderTableRowContent; },
/* harmony export */   "lG": function() { return /* binding */ addPrefixAfterPlusMinusNotation; },
/* harmony export */   "nE": function() { return /* binding */ getRealizedPnLText; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "qx": function() { return /* binding */ formatCeilToDecimals; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62974);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var global_Securities_utils_currencyFormatter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2941);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74380);





var renderTableRowContent = function(text, dataObject, children) {
    if (dataObject.groupDate) {
        return {
            children: text,
            props: {
                colSpan: 0
            }
        };
    }
    return children;
};
var formatPrice = function(price) {
    var replaceZero = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, decimals = arguments.length > 2 ? arguments[2] : void 0;
    var formatedPrice = (0,utils_number__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(price, false, decimals ? "0.0" : "0,0");
    return Number(formatedPrice) === 0 && replaceZero ? "-" : formatedPrice;
};
var formatPriceRoundDown = function(price) {
    var replaceZero = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, decimalRanges = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var decimal = "0".repeat(decimalRanges);
    var formattedPrice = numeral__WEBPACK_IMPORTED_MODULE_2___default()(Math.floor(Number(price) * 100) / 100).format("0,0[.]".concat(decimal), Math.floor);
    return Number(formattedPrice) === 0 && replaceZero ? "-" : formattedPrice;
};
/**
 * Formats a Late Fee value according to the specified rules.
 * @param {number} value - The value to format.
 * @returns {string} The formatted value as a string.
 */ var formatCeilToDecimals = function(num) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (num == null) return fallback;
    if (num > 1) {
        return numeral__WEBPACK_IMPORTED_MODULE_2___default()(Math.ceil(num)).format("0,0"); // Round up and format without decimals
    }
    var factor = Math.pow(10, 2); // 2 decimals
    return numeral__WEBPACK_IMPORTED_MODULE_2___default()(Math.ceil(num * factor) / factor).format("0.[00]"); // Keep up to 2 decimals
};
var formatDate = function(date) {
    var formatedDate = moment__WEBPACK_IMPORTED_MODULE_0___default()(date).format("D MMM YYYY");
    if (formatedDate === "Invalid date") {
        return moment__WEBPACK_IMPORTED_MODULE_0___default()(date, "DD/MM/YYYY").format("D MMM YYYY");
    }
    return formatedDate;
};
var getRealizedPnLText = function(dataObject) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var prefixAmount = dataObject.realized_amount > 0 ? "+" : "";
    var prefixPercentage = dataObject.realized_percentage > 0 ? "+" : "";
    var amount = decimals ? formatPriceRoundDown(dataObject.realized_amount, false, decimals) : formatPrice(dataObject.realized_amount, false, decimals);
    var percentage = (0,utils_number__WEBPACK_IMPORTED_MODULE_1__/* .formatPercentage */ .rl)(dataObject.realized_percentage, false);
    var isDividend = dataObject.command === _types__WEBPACK_IMPORTED_MODULE_3__/* .HistoryType.DIVIDEND */ .Z3.DIVIDEND;
    var isSellFR = dataObject.command === _types__WEBPACK_IMPORTED_MODULE_3__/* .HistoryType.SELL_FR */ .Z3.SELL_FR;
    var isCouponFR = dataObject.command === _types__WEBPACK_IMPORTED_MODULE_3__/* .HistoryType.COUPON_FR */ .Z3.COUPON_FR;
    var isCapitalReduction = dataObject.command === _types__WEBPACK_IMPORTED_MODULE_3__/* .HistoryType.CAPITAL_REDUCTION */ .Z3.CAPITAL_REDUCTION;
    if (!isDividend && !isSellFR && !isCouponFR && !isCapitalReduction) {
        return "".concat(prefixAmount).concat(amount, " (").concat(prefixPercentage).concat(percentage, ")");
    }
    return "".concat(prefixAmount).concat(amount);
};
var addPrefixAfterPlusMinusNotation = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var price = Math.abs(value);
    return (0,global_Securities_utils_currencyFormatter__WEBPACK_IMPORTED_MODULE_4__/* .getFormattedCurrency */ .c)(price);
};
var addPlusMinusIndicator = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var indicator = "";
    if (value > 0) {
        indicator = "+";
    }
    if (value < 0) {
        indicator = "-";
    }
    return indicator;
};


/***/ }),

/***/ 3194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ shimmerTableData; },
/* harmony export */   "R": function() { return /* binding */ shimmerColumns; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41080);



var shimmerColumns = [
    {
        key: "display_as",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            paragraph: false,
            title: {
                style: {
                    margin: "auto"
                }
            },
            loading: true,
            active: true
        }),
        dataIndex: "display_as",
        className: "td-mobile history-order-item",
        width: "100%",
        render: function() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                paragraph: false,
                title: {
                    style: {
                        margin: "auto"
                    }
                },
                loading: true,
                active: true
            });
        }
    }, 
];
var shimmerTableData = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Array(10)).map(function(_) {
    return {
        display_as: ""
    };
});


/***/ }),

/***/ 19254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  padding: 3px;\n\n  & > .ant-checkbox {\n    top: 0;\n\n    & > .ant-checkbox-inner {\n      width: 18px;\n      height: 18px;\n      border-radius: 4px;\n    }\n  }\n\n  & > .ant-checkbox-checked::after {\n    border-radius: 4px;\n  }\n\n  & > span:nth-child(2) {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47b14e33-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 2941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getFormattedCurrency; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);

var getFormattedCurrency = function(value) {
    var intlOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _currencyPrefix = intlOptions.currencyPrefix, currencyPrefix = _currencyPrefix === void 0 ? "Rp" : _currencyPrefix, options = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(intlOptions, [
        "currencyPrefix"
    ]);
    return "".concat(currencyPrefix).concat(value.toLocaleString(undefined, options));
};


/***/ })

}]);